<template>
  <div>
    <el-dialog :title="$t('message.businessTranslationUser')" :close-on-click-modal="false"
      :visible.sync="$parent.businessTranslationDialogVisible" width="1500px">
      <div class="table">
        <ol>
          <!-- 选择 -->
          <li class="flex05">
            <el-checkbox v-model="checked" @change="allChecked"> </el-checkbox>
          </li>
          <!-- 选择 -->
          <li class="flex05">NO</li>
          <!--  店铺信息-->
          <li class="flex15">
            {{ $t("message.storeInformation") }}
          </li>
          <!--照片-->
          <li>{{ $t("message.pic") }}</li>
          <!-- 商品属性 -->
          <li class="flex15">{{ $t("message.commodityAttribute") }}</li>
          <!--业务报价  -->
          <li>{{ $t("message.businessOffer") }}</li>
          <!-- 财务付款后数量 -->
          <li>{{ $t("message.afterFinancialPaymentNum") }}</li>
          <!-- 财务付款后金额 -->
          <li>{{ $t("message.afterFinancialPaymentKin") }}</li>
          <!--商品状态  -->
          <li>{{ $t("message.itemStatus") }}</li>
          <!-- 问题图片 -->
          <li class="flex2">{{ $t("message.problemPic") }}</li>
          <!-- 问题产品数 -->
          <li>{{ $t("message.problemNunber") }}</li>
          <!-- 问题描述  -->
          <li class="flex2">{{ $t("message.problemDescription") }}</li>
          <!-- 业务翻译  -->
          <li class="flex2">{{ $t("message.businessTranslationUser") }}</li>
        </ol>
        <!-- 订单详情 -->
        <div class="detail" v-for="(item, index) in disposeList" :key="index">
          <!-- 交易号 -->
          <div class="head">
            {{ $t("message.transactionNumber") }}:
            <a :href="'https://trade.1688.com/order/new_step_order_detail.htm?orderId=' +
              item.purchase_no
              " v-if="item.purchase_no" target="_blank">
              {{ item.purchase_no }}</a>
            <span v-else> ———— </span>
            <span style="margin-left: 50px;"> 订单号: <router-link :to="'/orderPaymentDetail?order_sn=' + item.order_sn"
                target="_blank">{{ item.order_sn }}</router-link></span>
          </div>
          <ul v-for="(items, indexs) in item.list" :key="indexs">
            <li class="flex05">
              <div class="template">
                <el-checkbox v-model="items.checked" @change="choice"></el-checkbox>
              </div>
            </li>
            <li class="flex05">{{ items.sorting }}</li>
            <!-- 选择 -->
            <!--  店铺信息-->
            <li class="flex15">
              <div class="template">
                <p>{{ items.shop_name }}</p>
                <p>{{ items.from_platform }}</p>
                <p>{{ items.shop_id }}</p>
              </div>
            </li>
            <!--照片-->
            <li>
              <div class="img">
                <el-popover placement="right" width="300" trigger="hover">
                  <img :src="items.pic" alt="" style="width: 300px; height: 300px" />
                  <a :href="items.link" target="_blank" slot="reference">
                    <img :src="items.pic" alt="" />
                  </a>
                </el-popover>
              </div>
            </li>
            <!-- 商品属性 -->
            <li class="flex15">
              <div class="template">
                <p v-for="(skuItem, skuIndex) in items.detail_y" :key="skuIndex">
                  <span>{{ skuItem.key }}:</span>
                  <span>{{ skuItem.value }}</span>
                </p>
              </div>
            </li>
            <!--业务报价  -->
            <li>
              <div class="template">
                <!-- 单价 -->
                <!-- <p>
                  {{ $t("message.unitPrice") }}:{{ items.confirm_dicker_price }}
                </p> -->
                <!-- 价格 -->
                <p>{{ $t("message.price") }}:{{ items.offer_price_bak }}</p>

                <!-- 数量 -->
                <p>{{ $t("message.number") }}:{{ items.offer_num_bak }}</p>
                <!-- 运费-->
                <p>{{ $t("message.freight") }}:{{ items.offer_freight_bak }}</p>
              </div>
            </li>
            <!-- 财务付款后数量 -->
            <li>
              <div class="template">
                <!-- 可入库 -->
                <p>
                  {{ $t("message.canBePutIntoStorage") }}:{{
                    items.possible_num ? items.possible_num : "——"
                  }}
                </p>
                <!-- 已到货 -->
                <p>
                  {{ $t("message.itHasArrived") }}:{{
                    items.storage_num ? items.storage_num : "——"
                  }}
                </p>
                <!-- 已出货 -->
                <p>
                  {{ $t("message.hasBeenShipped") }}:{{
                    items.p_num ? items.p_num : "——"
                  }}
                </p>
                <!-- 运费 -->
                <p>
                  {{ $t("message.freight") }}:{{
                    items.confirm_freight ? items.confirm_freight : "——"
                  }}
                </p>
              </div>
            </li>
            <!-- 财务付款后金额 -->
            <li>
              <div class="template">
                <!-- 价格 -->
                <p>{{ $t("message.price") }}:{{ items.confirm_price }}</p>
                <!-- 运费-->
                <p>{{ $t("message.freight") }}:{{ items.confirm_freight }}</p>
              </div>
            </li>
            <!--商品状态  -->
            <li>{{ items.product_status_name }}</li>
            <!-- 问题图片 -->
            <li class="flex2">
              <div class="imgList">
                <div class="imgs" v-for="(imgs, imgIndex) in items.problem_goods_image" :key="imgIndex">
                  <div class="index">
                    {{ imgIndex + 1 }}
                  </div>
                  <img v-if="imgs.image"
                    :src="imgs.isOss ? imgs.image + '?x-oss-process=image/resize,p_10' : imgs.image" class="avatar"
                    @click="handlePictureCardPreview(imgs.image)" />
                  <el-checkbox v-model="imgs.checked" @change="switchImageShow(imgs)"></el-checkbox>
                </div>
              </div>
            </li>
            <!-- 问题产品数 -->
            <li>
              {{ items.num }}
            </li>
            <!-- 具体问题描述 -->
            <li class="flex2">
              {{ items.description }}
            </li>
            <!-- 业务翻译 -->
            <li class="flex2">
              <el-input v-model="items.content_f" type="textarea" :placeholder="$t('message.businessTranslationUser')"
                onfocus="this.select()" @input="allContent(items)"></el-input>
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--业务翻译  -->
        <el-button type="primary" @click="translate">{{
          $t("message.businessTranslationUser")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 查看大图 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="picDialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    disposeList: { type: Array },
  },
  data() {
    return {
      picDialogVisible: false,
      dialogImageUrl: "",
      checkedList: [],
      checked: false,
    };
  },
  computed: {},
  methods: {

    // 问题产品-业务翻译
    translate() {
      let datas = {
        data: [],
      };
      this.disposeList.forEach((item) => {
        item.list.forEach((items) => {
          datas.data.push({
            problem_goods_id: items.problem_goods_id,
            content: items.content_f,
          });
        });
      });

      // if (!datas.data.every((item) => item.content_f != ""))
      //   return this.$message.error("有订单未翻译内容");
      this.$api.problemApi.translate(datas).then((res) => {
        if (res.code != 0) return this.$message.error(res.msg);
        this.$message.success(res.msg);
        this.$parent.businessTranslationDialogVisible = false;
        this.$parent.problemList();
      });
      console.log(datas);
    },
    //单选
    choice() {
      let list = []
      this.disposeList.forEach(item => {
        item.list.forEach(items => {
          if (items.checked) {
            list.push(item)
          }

        })
      })
      this.checked = list.every(item => item.checked)
      this.$forceUpdate()
    },
    //全选
    allChecked() {
      this.disposeList.forEach(item => {
        item.list.forEach(items => {
          items.checked = this.checked
        })
      })
      this.$forceUpdate()
    },
    //批量修改
    allContent(data) {
      if (data.checked) {
        this.disposeList.forEach(item => {
          item.list.forEach(items => {
            if (items.checked) {
              items.content_f = data.content_f
            }

          })
        })
      }
    },
    // 查看大图
    handlePictureCardPreview(url) {
      this.dialogImageUrl = url;
      this.picDialogVisible = true;
    },
    //切换图片是否显示给客户看
    switchImageShow(item) {
      let datas = {
        list: [
          {
            image_id: item.id,
            client_show: item.checked ? 1 : 0,
          }
        ]
      }
      this.$api.problemApi.switchImageShow(datas).then((res) => {
        this.$message.success(res.msg)
      })
    },
  },
};
</script>
<style lang='scss' scoped>
@import "@/css/mixin.scss";

.table {
  padding: 0 10px;
  max-height: 600px;
  overflow-y: auto;

  ol {
    display: flex;
    font-size: 14px;
    height: 40px;
    background-color: #edeff4;
    position: sticky;
    left: 0;
    top: 0;
    z-index: 999;
  }

  ul {
    display: flex;
    border-bottom: 1px solid #e8e8e8;
    padding: 10px 0;
    font-size: 12px;
    transition: 0.25s;

    &:hover {
      background-color: #eee;
      cursor: pointer;
    }

    li {
      width: 100%;
      overflow: hidden;

      //   max-height: 80px;
      label {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .template {
        text-align: left;
        width: 100%;
        max-height: 100px;

        p {
          line-height: 20px;
        }
      }

      .scope {
        max-height: 100px;

        p {
          line-height: 20px;
        }
      }

      .imgList {
        display: flex;
        flex-wrap: wrap;
        text-align: center;

        .el-checkbox {
          height: 25px;
        }

        .imgs {
          margin: 0 20px 10px 0;
          position: relative;

          .index {
            position: absolute;
            top: -0px;
            left: -0px;
            width: 15px;
            height: 15px;
            background-color: #B4272D;
            border-radius: 50%;
            text-align: center;
            line-height: 15px;
            color: #fff;
            z-index: 99;
          }

          &:nth-child(even) {
            margin-right: 0;
          }

          &:nth-child(n + 2) {
            margin-bottom: 0;
          }

          img {
            width: 50px;
            height: 50px;
          }
        }
      }
    }

    .img {
      img {
        width: 60px;
        height: 60px;
        border-radius: 4px;
      }
    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 0 3px;
  }

  .flex05 {
    flex: 0.5;
  }

  .flex15 {
    flex: 1.3;
  }

  .flex2 {
    flex: 1.7;
  }

  .flex25 {
    flex: 2.3;
  }

  .detail {
    .head {
      height: 50px;
      display: flex;
      background-color: #dedeef;
      font-size: 14px;
      line-height: 50px;
      padding: 0 20px;

      a {
        color: #000;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  .noData {
    padding: 20px 0;
    text-align: center;
  }
}

/deep/.el-textarea__inner {
  height: 80px;
  padding: 3px;
}

/deep/.el-input__inner {
  padding: 2px;
  text-align: center;
}
</style>